// extracted by mini-css-extract-plugin
export default {"rotate":"Layout_rotate__sGe09","body":"Layout_body__2UuOM","hideSide":"Layout_hideSide__U4AU8","footer":"Layout_footer__Rg6v4"};